import { usePinboardView } from "./use-pinboard-view";

export function PinboardPage() {
  return usePinboardView();
}
